import { Injectable } from '@angular/core';

import { Detail } from 'app/interfaces/detail.model';
import { ElasticQuery } from 'app/interfaces/elastic-query.model';
import { QueryType } from 'app/enums/query-type.enum';
import { ElasticSearchResult } from 'app/interfaces/elastic-search-result.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class DetailService {
  constructor(private _http: HttpClient) {}

  fields() {
    return this._http.get(`${environment.apiUrl}projects/Fields`);
  }

  get(size: number = 12, from: number = 0, filters: Array<ElasticQuery>): Observable<ElasticSearchResult> {
    if (!filters) {
      filters = [
        {
          Type: QueryType.MATCHALL,
          Field: null,
          Values: null,
        },
      ];
    }

    return this._http.post(`${environment.apiUrl}details/find?size=${size}&from=${from}`, filters) as Observable<ElasticSearchResult>;
  }

  save(detail: Detail) {
    if (detail.Id) {
      return this._http.put(`${environment.apiUrl}details/update`, detail, { withCredentials: true });
    } else {
      return this._http.post(`${environment.apiUrl}details/save`, detail, { withCredentials: true });
    }
  }

  single(id): Observable<Detail> {
    return this._http.get(`${environment.apiUrl}details/${id}`) as Observable<Detail>;
  }
}
